module.exports = __webpack_public_path__ + "img/3.40fa80bb.png";